import styles from './GeneralDetails.module.scss';

const GeneralDetails = (props) => {
	const { fields } = props;
	return (
		<div className={`${styles.root} row`}>
			<div
				style={{
					flexBasis: '50%',
				}}
			>
				{/* product name */}
				<div className='form-field row'>
					<div className='form-label'>Product Name</div>
					<div className='form-value'>{fields.productName}</div>
				</div>
				{/* brand name */}
				<div className='form-field row'>
					<div className='form-label'>Product Description</div>
					<div className='form-value'>{fields.productDescription}</div>
				</div>
			</div>
			<div
				style={{
					marginLeft: '3rem',
					flexBasis: '50%',
				}}
			>
				{/* display image */}
				<div
					className='form-field row'
					style={{
						alignItems: 'flex-start',
					}}
				>
					<span className='form-label'>Display Image</span>
					<div className='display-pic-root'>
						<div className='display-pic-preview'>
							<img
								src={fields.image}
								className={`display-pic ${
									fields.image ? 'show' : 'hide'
								}`}
								alt='product-display'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

GeneralDetails.defaultProps = {
	fields: {},
};

export default GeneralDetails;
